var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7167_29028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4613 31.7362C53.4613 31.7362 53.4613 31.7233 53.4613 31.7104C53.5517 31.4908 53.6034 31.2583 53.6034 30.9999C53.6034 30.7416 53.5517 30.5091 53.4613 30.2895C53.4613 30.2895 53.4613 30.2766 53.4613 30.2637C53.3579 30.0183 53.2159 29.8116 53.035 29.6308L37.535 14.1308C36.7729 13.3687 35.5459 13.3687 34.7967 14.1308C34.0346 14.8928 34.0346 16.1199 34.7967 16.8691L46.99 29.0624H10.3325C9.26044 29.0624 8.39502 29.9279 8.39502 30.9999C8.39502 32.072 9.26044 32.9374 10.3325 32.9374H46.99L34.7967 45.1308C34.0346 45.8929 34.0346 47.1199 34.7967 47.8691C35.1713 48.2437 35.675 48.4374 36.1659 48.4374C36.6567 48.4374 37.1604 48.2437 37.535 47.8691L53.035 32.3691C53.2159 32.1883 53.3579 31.9687 53.4613 31.7362Z",
    fill: "#B3FF01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7167_29028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3170d91b9b08398883869d97d6fd6025.svg";
export { ForwardRef as ReactComponent };